module.exports = __webpack_public_path__ + "static/media/043-montserrat.7b430812.svg";